module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_6.dd87c556.jpg";